import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import {
  isError, isFinishedFetching, isSuccess, ResourcesItem,
} from 'redux-and-the-rest';
import { UserModel } from './models/userModel';
import { ApplicationState } from './redux/types';

import { createGuestUser, getOrFetchUser } from './redux/reducers/userReducer';
import LoadingIndicator from './components/shared/LoadingIndicator';

interface Props extends React.ComponentProps<'div'> {
   user: ResourcesItem<UserModel>;
}

/**
 * Wraps components that require at least a Guest user account to save items against
 * If no user exists in the store, a guest user is created
 */
const GuestGate = ({
  children,
  user,
}: Props) => {
  useEffect(() => {
    /**
     * If a User has logged out, a new session will be attempted by the hydration component, based
     * on a change to the auth token.
     * This will leave the User in an Error state, specifically 401 for a rejected request for a new session.
     * The or statement here is to request a Guest User Session for the application in a Logged out User state.
     * TODO: look at stopping hydration for when there is no auth code in the store. Perhaps not trivial and
     * we are looking to/need to get this fixed asap.
     */
    if (isFinishedFetching(user) || (isError(user) && user.status.httpCode === 401)) {
      if (Object.keys(user?.values).length === 0) {
        createGuestUser();
      }
    }
  }, [user]);

  /**
   * We only allow the children to be rendered when the user has either been successfully created or fetched.
   */
  if (isSuccess(user)) {
    return (
      <>
        {children}
      </>
    );
  }

  return <LoadingIndicator />;
};

const mapStateToProps = ({ users }: ApplicationState) => ({
  user: getOrFetchUser(users),
});

export default connect(mapStateToProps)(GuestGate);
